import { render, staticRenderFns } from "./AddMarque.vue?vue&type=template&id=64e0688f&"
import script from "./AddMarque.vue?vue&type=script&lang=js&"
export * from "./AddMarque.vue?vue&type=script&lang=js&"
import style0 from "./AddMarque.vue?vue&type=style&index=0&id=64e0688f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports